import { useEffect, useMemo, useState } from 'react';
import { RawRevisionDataPerScenario } from 'helper/flux/automatic';
import { useLazyGetUnicenarioPerScenariosQuery } from 'services/api/products/flux';
import { useSelector } from 'react-redux';
import {
  selectFluxAutomaticControlPanelMltOption,
  selectFluxAutomaticControlPanelSelectedRevision,
  selectFluxAutomaticControlPanelUnicenarioScenario,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

interface UnicenarioScenarioError {
  data: { description: string }
}

export default function useUnicenarioScenarios(previsao: string) {
  const [trigger] = useLazyGetUnicenarioPerScenariosQuery();
  const unicenarioScenario = useSelector(selectFluxAutomaticControlPanelUnicenarioScenario);
  const cenario = unicenarioScenario ?? '';
  const review = useSelector(selectFluxAutomaticControlPanelSelectedRevision);
  const revision = review ?? '';
  const [errorMessage, setErrorMessage] = useState('');
  const [data, setData] = useState<RawRevisionDataPerScenario | undefined>(undefined);
  const [isFetching, setIsFetching] = useState(false);
  const unidade = useSelector(selectFluxAutomaticControlPanelMltOption);
  const triggerParameters = useMemo(() => ({
    data_acomph: 'latest',
    data_previsao: previsao,
    versao: 'latest',
    cenario,
    unidade,
    revision,
  }), [cenario, previsao, revision, unidade]);

  useEffect(() => {
    if (cenario && revision && previsao) {
      (async () => {
        setIsFetching(true);
        const res = await trigger(triggerParameters);
        const responseError = res?.error as UnicenarioScenarioError | undefined;
        setErrorMessage(responseError?.data.description ?? '');
        setData(res?.data);
        setIsFetching(false);
      })();
    } else {
      setData(undefined);
      setIsFetching(false);
    }
  }, [cenario, revision, previsao, trigger, triggerParameters]);

  return {
    data, isFetching, errorMessage,
  };
}
